import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { CategoryNode } from '../../api/catalog';

type Props = {
  nodes: CategoryNode[];
  depth?: number;
};

export function CategoryTreeView({ nodes, depth = 0 }: Props) {
  return (
    <ul className={depth === 0 ? 'space-y-1' : 'ml-4 mt-1 space-y-1 border-l pl-3'} role="tree">
      {nodes.map((node) => (
        <CategoryTreeItem key={node.category.id} node={node} depth={depth} />
      ))}
    </ul>
  );
}

function CategoryTreeItem({ node, depth }: { node: CategoryNode; depth: number }) {
  const [open, setOpen] = useState(depth < 2);
  const hasChildren = (node.children?.length ?? 0) > 0;
  const cat = node.category;

  return (
    <li role="treeitem" aria-expanded={hasChildren ? open : undefined}>
      <div className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-slate-50">
        {hasChildren ? (
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="h-5 w-5 shrink-0 rounded text-xs text-slate-500 hover:bg-slate-200"
            aria-label={open ? 'Collapse' : 'Expand'}
          >
            {open ? '−' : '+'}
          </button>
        ) : (
          <span className="inline-block h-5 w-5 shrink-0" />
        )}
        <Link to={`/catalog/categories/${cat.id}/edit`} className="font-medium text-slate-900 hover:underline">
          {cat.name}
        </Link>
        <span className="text-xs text-slate-400">{cat.path}</span>
        {cat.hsn_code && <span className="rounded bg-amber-50 px-1.5 py-0.5 text-xs text-amber-800">HSN {cat.hsn_code}</span>}
        {cat.gst_code && <span className="rounded bg-emerald-50 px-1.5 py-0.5 text-xs text-emerald-800">GST {cat.gst_code}</span>}
      </div>
      {hasChildren && open && <CategoryTreeView nodes={node.children ?? []} depth={depth + 1} />}
    </li>
  );
}
